import * as React from 'react';
import { useState } from 'react'
import useWindowSize from '../../utils/useWindowSize';
import { Card, Button, Form, FormGroup, Table } from 'react-bootstrap'
import { useApprovedContext } from '../../contexts/ApprovedContext';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { FlyingListInfo, MemberType } from '../../contexts/ContextTypes';

const currentDateTime = new Date();

const fromDate = new Date(currentDateTime.getUTCFullYear(), currentDateTime.getUTCMonth(), currentDateTime.getDate());
fromDate.setDate(fromDate.getDate() - 7);


const toDate = new Date(currentDateTime.getUTCFullYear(), currentDateTime.getUTCMonth(), currentDateTime.getDate());
toDate.setDate(toDate.getDate() + 7);

const toDatePlusOne = new Date(currentDateTime.getUTCFullYear(), currentDateTime.getUTCMonth(), currentDateTime.getDate());
toDatePlusOne.setDate(toDatePlusOne.getDate() + 8);

export default function DriversDashboard() {
  const windowSize = useWindowSize();
  //const [ updateCount, setUpdateCount ] = useState<number>(0);
  const { getFlyingListInfo } = useApprovedContext();
  const [selected, setSelected] = useState<Date | undefined>(undefined);
  const [selectedFlyingList, setSelectedFlyingList] = useState<FlyingListInfo | undefined>(undefined)
  const [finalFlyingLists, setFinalFlyingLists] = useState<Array<FlyingListInfo>>([]);
  const [hiddenDays, setHiddenDays] = useState<Array<Date>>([]);

  function markDayAsScrubbed() {
    //setUpdateCount(current => current + 1);
  }

  // https://stackoverflow.com/questions/4413590/javascript-get-array-of-dates-between-2-dates
  const getDaysArray = function (from: Date, to: Date): Array<Date> {
    const arr = [];
    for (const dt = new Date(from); dt <= new Date(to); dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(dt));
    }
    return arr;
  };

  // TODO: Check how this works at the start and end of years (16 down)
  React.useEffect(() => {
    async function getFlyingLists() {
      const flyingLists = await Promise.all(getDaysArray(fromDate, toDate).map(getFlyingListInfo));

      setFinalFlyingLists(flyingLists.filter(flyingList => flyingList.final));

      setHiddenDays(
        getDaysArray(
          new Date(fromDate.getFullYear(), fromDate.getMonth() - 2),
          fromDate
        ).concat(
          flyingLists
            .filter(flyingList => !flyingList.final)
            .map(flyingList => flyingList.flyingListDate)
        ).concat(
          getDaysArray(
            toDatePlusOne,
            new Date(toDate.getFullYear(), toDate.getMonth() + 4)
          )
        )
      );
    }

    getFlyingLists();
  }, [getFlyingListInfo])

  React.useEffect(() => {
    if (selected === undefined)
      return;
    setSelectedFlyingList(finalFlyingLists.find(flyingList => flyingList.flyingListDate.valueOf() === selected.valueOf()))
  }, [selected, finalFlyingLists])

  return (
    <Card>
      <Card.Header>
        <h2>Driver Dashboard</h2>
        <p>Past and future flying days will be shown below, allowing you to mark days as scrubbed, see who you will be driving and more (if more ever gets developed (Which it won't get fucked (TODO: Remove before pushing to prod I guess)))!</p>
      </Card.Header>
      <Card.Body>
        <Form>
          <FormGroup id="date" className="d-flex justify-content-center border rounded mb-3 p-3">
            <DayPicker
            className=''
              mode="single"
              required
              selected={selected}
              onSelect={setSelected}
              fromDate={fromDate}
              toDate={toDate}
              hidden={hiddenDays}
              numberOfMonths={windowSize.width > 768 ? toDate.getMonth() - fromDate.getMonth() + 1 : 1}
            />
            </FormGroup>
        </Form>
        {false && selected !== undefined &&
          <Form>
            <Button
              variant='danger'
              onClick={() => markDayAsScrubbed()}
            >
              Mark as Scrub
            </Button>
          </Form>
        }
        {selected !== undefined &&
          selectedFlyingList !== undefined &&
          <>
          <h3 className='text-center'> Flying List </h3>
            <Table>
              <thead>
                <tr>
                  <th className='text-center w-25'>User</th>
                  <th className='text-center w-25'>Email</th>
                  <th className='text-center w-25'>Phone Number</th>
                </tr>
              </thead>
              <tbody>
                {selectedFlyingList.currentFlyingList.map(user => (
                  <tr key={user.uid}>
                    <td className='text-center'>
                      {((user.isDriver) ? "🚗 " : "") + user.firstName + " " + user.lastName}
                      {user.memberType === MemberType.trial && <span className="badge bg-warning text-dark ms-2">TRIAL</span>}
                    </td>
                    <td className='text-center'>{user.email === undefined ? "Not Set" : user.email}</td>
                    <td className='text-center'>
                      {user.phoneNumber === undefined ? "Not Set" : (<a href={`tel:${user.phoneNumber}`}>{user.phoneNumber}</a>)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        }
        {selected !== undefined &&
          selectedFlyingList !== undefined &&
          (selectedFlyingList
            .availableUsers
            .filter(user =>
              selectedFlyingList.currentFlyingList.find(selectedUser => selectedUser.uid === user.uid) === undefined
            ).length !== 0) &&
          <>
          <h3 className='text-center pt-3'> Extra Availability </h3>
            <Table>
              <thead>
                <tr>
                  <th className='text-center w-25'>User</th>
                  <th className='text-center w-25'>Email</th>
                  <th className='text-center w-25'>Phone Number</th>
                </tr>
              </thead>
              <tbody>
                {selectedFlyingList.availableUsers
                  .filter(user => selectedFlyingList.currentFlyingList.find(selectedUser => selectedUser.uid === user.uid) === undefined)
                  .map(user => (
                    <tr key={user.uid}>
                      <td className='text-center'>
                        {((user.isDriver) ? "🚗 " : "") + user.firstName + " " + user.lastName}
                        {user.memberType === MemberType.trial && <span className="badge bg-warning text-dark ms-2">TRIAL</span>}
                      </td>
                      <td className='text-center'>{user.email === undefined ? "Not Set" : user.email}</td>
                      <td className='text-center'>{user.phoneNumber === undefined ? "Not Set" : (<a href={`tel:${user.phoneNumber}`}>{user.phoneNumber}</a>)}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </>
        }


      </Card.Body>
    </Card>
  )
}
